import React from 'react';

// import DeleteIcon from '@material-ui/icons/Delete';
import { lighten, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
// import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
// import CustomTitle from './title';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

export default function CustomTableToolbar({ children, ...props }) {
  const classes = useToolbarStyles();
  const { numSelected, buttons } = props;

  return (
    <Toolbar
      className={clsx(classes.root, { [classes.highlight]: numSelected > 0 })}
    >
      <Typography
        id="tableTitle"
        className={classes.title}
        color="primary"
        variant="h4"
        gutterBottom={false}
      >
        {children}
      </Typography>

      {numSelected > 0 && (
        <Typography
          className={classes.title}
          color="inherit"
          variant="h5"
          component="div"
        >
          {numSelected} {numSelected > 1 ? ' selecionados' : ' selecionado'}
        </Typography>
      )}

      {false && numSelected < 1 && (
        <Tooltip title="Filtrar">
          <IconButton aria-label="filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}

      {/* {numSelected > 0 && (<Tooltip title="Remover"><IconButton aria-label="delete"><DeleteIcon /></IconButton></Tooltip>)} */}
      {numSelected > 0 &&
        buttons.map((button, index) => {
          return (
            <Tooltip key={'tool-button-' + index} title={button.title}>
              {(button.fab && (
                <Fab
                  aria-label={'filter'}
                  color={button.color || 'primary'}
                  onClick={button.onClick}
                >
                  {button.icon}
                </Fab>
              )) || (
                <IconButton
                  color={button.color || 'primary'}
                  aria-label="deposit"
                  onClick={button.onClick}
                >
                  {button.icon}
                </IconButton>
              )}
            </Tooltip>
          );
        })}
    </Toolbar>
  );
}
